export const ROLES = {
  ADMIN: 'ADMIN',
  MANAGEMENT: 'MANAGEMENT',
  SALES: 'SALES',
  USER: 'USER',
} as const;
